import React, { useState } from "react";
import { updateAssetReferral } from "services/assetRecoveryService";
import { useTooltip } from "context/TooltipProvider";
import { Referral } from "types";
import ReadMoreText from "components/ReadMoreText";
import { useTranslation } from "react-i18next";

interface ReinitiateContainerProps {
  referralId: string;
  action_status?: string;
  isAssetCoordinator: boolean;
  onReinitiateCreated?: (res: any) => void;
  setActiveTab?: (tab: string) => void;
  referral?: Referral | null;
}

export default function ReinitiateContainer({
  referralId,
  action_status,
  isAssetCoordinator,
  onReinitiateCreated,
  setActiveTab,
  referral,
}: ReinitiateContainerProps) {
  const [isApproving, setIsApproving] = useState(false);
  const [isForwarding, setIsForwarding] = useState(false);
  const { showTooltip } = useTooltip();
  const { t } = useTranslation();

  const handleApproveReinitiate = async () => {
    try {
      setIsApproving(true);

      const formData = new FormData();
      formData.append("action_status", "Reinitiate Approved");
      const response = await updateAssetReferral(referralId, formData);
      if (onReinitiateCreated && response) {
        onReinitiateCreated(response);
        setActiveTab?.("Referral");
      }
      showTooltip(t("reinitiate_request_approved_successfully"), "success");
    } catch (error) {
      console.error("Error approving reinitiate:", error);
      showTooltip(t("failed_to_approve_reinitiate_request"), "error");
    } finally {
      setIsApproving(false);
    }
  };

  const handleRejectReinitiate = async () => {
    try {
      setIsForwarding(true);

      const formData = new FormData();
      formData.append("action_status", "Reinitiate Rejected");

      const response = await updateAssetReferral(referralId, formData);
      if (onReinitiateCreated && response) {
        onReinitiateCreated(response);
        setActiveTab?.("Referral");
      }
      showTooltip(t("reinitiate_request_rejected_successfully"), "success");
    } catch (error) {
      console.error("Error rejecting reinitiate:", error);
      showTooltip(t("failed_to_reject_reinitiate_request"), "error");
    } finally {
      setIsForwarding(false);
    }
  };
  console.log({
    action_status,
    st: action_status === "Reinitiate Requested",
    isAssetCoordinator,
  });
  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <p
        className="font-medium"
        style={{ color: " var(--Prime-Blue, #0A1D39)" }}
      >
        Reinitiation Requested
      </p>
      <div className="flex flex-col">
        <span style={{ color: "#432101AB", fontSize: "15px" }}>Summary</span>
        <div style={{ color: "var(--Prime-Blue, #0A1D39)" }}>
          {referral?.reinitiate_request_summary ? (
            <ReadMoreText
              text={referral?.reinitiate_request_summary}
              maxLines={3}
              fontSize="14px"
            />
          ) : (
            "—"
          )}
        </div>
      </div>
      {isAssetCoordinator && action_status === "Reinitiate Requested" && (
        <div className="mt-3 flex  gap-3">
          <button
            onClick={handleRejectReinitiate}
            disabled={isForwarding}
            className="px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-60 transition-colors"
          >
            {isForwarding ? "Processing..." : "Reject"}
          </button>

          <button
            onClick={handleApproveReinitiate}
            disabled={isApproving}
            className="px-4 py-2 text-sm font-medium bg-black text-white rounded-md hover:bg-gray-700 disabled:opacity-60 transition-colors"
          >
            {isApproving ? "Processing..." : "Approve"}
          </button>
        </div>
      )}
    </div>
  );
}
